import { render, staticRenderFns } from "./AlterarSenhaModal.vue?vue&type=template&id=ebe8eb34"
import script from "./AlterarSenhaModal.vue?vue&type=script&lang=js"
export * from "./AlterarSenhaModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports